var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopWinners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "top-10",
    transform: "translate(0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M28,14a13.96,13.96,0,0,1-4.278,10.073c-.764.737-3.673-1.238-4.588-.689-.52.312,1,3.219.44,3.462h0A14.021,14.021,0,1,1,28,14Z",
    transform: "translate(-0.003 0)",
    fill: "#fcc021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M27.867,16.778a2.813,2.813,0,0,1-.729,1.168L23.695,21.3a2.828,2.828,0,0,0-.816,2.507l.813,4.732c.013.073.022.144.029.216a14.026,14.026,0,0,1-4.149,2.768l-4.253-2.232a2.84,2.84,0,0,0-2.64,0L8.425,31.52l0,0a2.837,2.837,0,0,1-4.145-2.77c.007-.072.016-.143.029-.216L5.118,23.8A2.828,2.828,0,0,0,4.3,21.3L.858,17.946a2.813,2.813,0,0,1-.729-1.168,2.867,2.867,0,0,1,.718-2.885,2.8,2.8,0,0,1,1.584-.778l4.759-.691a2.836,2.836,0,0,0,2.136-1.549l2.128-4.3a2.839,2.839,0,0,1,5.088,0l2.128,4.3a2.836,2.836,0,0,0,2.136,1.549l4.759.691a2.8,2.8,0,0,1,1.584.778,2.867,2.867,0,0,1,.718,2.885Z",
    transform: "translate(0 -4.706)",
    fill: "#da2d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M7.651,28.5l.827-4.724a2.791,2.791,0,0,0-.83-2.5l-3.5-3.345a2.812,2.812,0,0,1,1.6-4.822l4.843-.689a2.884,2.884,0,0,0,2.174-1.547l2.166-4.3a2.825,2.825,0,0,1,.955-1.086,2.924,2.924,0,0,0-4.223,1.086l-2.166,4.3a2.884,2.884,0,0,1-2.174,1.547L2.475,13.1a2.812,2.812,0,0,0-1.6,4.822l3.5,3.345a2.791,2.791,0,0,1,.83,2.5L4.383,28.5a2.875,2.875,0,0,0,4.189,2.98l.309-.159A2.774,2.774,0,0,1,7.651,28.5Z",
    transform: "translate(-0.002 -4.652)",
    fill: "#ce5e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M290.884,445.774a13.768,13.768,0,0,1-1.6.831h0l-3.921-2.075.283-.149a2.786,2.786,0,0,1,2.609,0Z",
    transform: "translate(-269.458 -419.927)",
    fill: "#950000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M150.53,167.654h-2.551a.57.57,0,1,0,0,1.139h.7v4.05a.57.57,0,1,0,1.139,0v-4.05h.711a.57.57,0,1,0,0-1.139Z",
    transform: "translate(-138.503 -155.871)",
    fill: "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M331.709,167.654h-1.286a.57.57,0,0,0-.57.572s0,.89,0,1.242a.572.572,0,0,0,0,.06v3.316a.57.57,0,1,0,1.139,0V171.4l.716,0a1.874,1.874,0,1,0,0-3.747Zm0,2.607-.711,0c0-.269,0-.568,0-.736,0-.144,0-.453,0-.734h.715a.734.734,0,1,1,0,1.468Z",
    transform: "translate(-310.764 -155.871)",
    fill: "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M215.69,167.654a2.879,2.879,0,1,0,2.879,2.879A2.883,2.883,0,0,0,215.69,167.654Zm0,4.619a1.74,1.74,0,1,1,1.74-1.74A1.742,1.742,0,0,1,215.69,172.273Z",
    transform: "translate(-200.278 -155.871)",
    fill: "#f9f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M341.617,6.879l.137.014a.923.923,0,0,0,1-.761l.254-1.471a.923.923,0,0,0-.815-1.075l-.34-.035a.923.923,0,0,0-1.017.887l-.051,1.492a.923.923,0,0,0,.828.95Z",
    transform: "translate(-322.401 -3.343)",
    fill: "#820f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M402.325,29.427l.111.081a.923.923,0,0,0,1.25-.157l.956-1.147a.923.923,0,0,0-.168-1.339l-.277-.2a.923.923,0,0,0-1.324.259l-.79,1.266A.923.923,0,0,0,402.325,29.427Z",
    transform: "translate(-380.215 -24.979)",
    fill: "#820f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M440.621,89.273l.056.126a.923.923,0,0,0,1.161.489l1.4-.515a.923.923,0,0,0,.524-1.243l-.14-.312a.923.923,0,0,0-1.276-.438l-1.317.7A.923.923,0,0,0,440.621,89.273Z",
    transform: "translate(-416.613 -82.394)",
    fill: "#820f4e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopWinners);
export default __webpack_public_path__ + "static/media/icon_top_winners.d9ad784c1a12369433b46579c34b02f6.svg";
export { ForwardRef as ReactComponent };